import React from 'react';
import ResultsContent from "./ResultContent";

const ResultsModal = ({
  showResultModal,
  selectedResultForView,
  activeResultTab,
  profilingLoading,
  profilingResults,
  dqLoading,
  dqResults,
  setShowResultModal,
  setSelectedResultForView,
  setActiveResultTab,
  assetName
}) => {
  if (!showResultModal || !selectedResultForView) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-lg shadow-xl w-4/5 h-[90vh] overflow-hidden">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">{assetName ? assetName : "Results"}</h2>
          </div>
          <button
            onClick={() => {
              setShowResultModal(false);
              setSelectedResultForView(null);
              setActiveResultTab("profile");
            }}
            className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-full"
            title="Close"
          >
            <svg
              className="h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Modal Body with Results Content */}
        <div className="overflow-y-auto h-[calc(90vh-80px)]">
          <ResultsContent
            activeResultTab={activeResultTab}
            setActiveResultTab={setActiveResultTab}
            profilingLoading={profilingLoading}
            profilingResults={profilingResults}
            dqLoading={dqLoading}
            dqResults={dqResults}
            assetName={assetName}
            showTabs={true}
          />
        </div>
      </div>
    </div>
  );
};

export default ResultsModal;